export default __webpack_public_path__ + "static/media/MiscellaneousFeed.47346c9e.webp";